import { FAT_CHECKLIST_SPEC_CATEGORY } from './fatSpecificationConstants';
import type { FatSpecificationTemplateDto } from './fatSpecificationTemplateTypes';

/**
 * Resolve the FAT checklist template row for a spool (same rules as Fabrication → Spools cards).
 */
export function findFatSpecificationTemplateForSpool(
  list: FatSpecificationTemplateDto[],
  spoolIndex1Based: number,
  spoolLabel: string,
): FatSpecificationTemplateDto | null {
  const want = spoolIndex1Based;
  const label = spoolLabel.trim();
  for (const t of list) {
    if (t.category !== FAT_CHECKLIST_SPEC_CATEGORY) continue;
    const si = t.spoolIndex;
    if (si != null && si > 0) {
      if (si === want) return t;
    }
  }
  for (const t of list) {
    if (t.category !== FAT_CHECKLIST_SPEC_CATEGORY) continue;
    if (t.spoolIndex != null && t.spoolIndex > 0) continue;
    if (want === 1 && (t.reference || '').trim() === label) return t;
  }
  if (want === 1) {
    const legacy = list.filter(
      (t) => t.category === FAT_CHECKLIST_SPEC_CATEGORY && (t.spoolIndex == null || t.spoolIndex < 1),
    );
    if (legacy.length === 1) return legacy[0] ?? null;
  }
  return null;
}
